import React, { useEffect, useRef,useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";
import $ from "jquery";
import moment from "moment";

import { createAxiosInstance } from "api/axiosConfig";
import { logoutFromHelper } from "api/Helper";
import {
  GET_ALL_DOCUMENT_TYPES,
  PATIENT_SEARCH_AUTOCOMPLETE_URL,
  STAFF_MEMBERS_CONTROLER_URL,
  WHO_AM_I,
} from "api/Service";
import { Select } from "components/ui/Select/Select";
import { useUploadDocument } from "features/patients/hooks/useUploadDocument";
import { Documentstatus, TaskPriority } from "utils/Constant";
import { pathGenerators } from "utils/routes";

import { logout } from "../../redux/auth/AuthSlice";
import { removeuser } from "../../redux/user/userSlice";
const DocumentModal = ({
  handleSaveTask,
  patient,
  refreshByPatientIdApi,
  refreshAllApi,
  fromPatient,
  fetchDocumentById,
}) => {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const uploadDocument = useUploadDocument({
    onSuccess: () => {
      if (refreshByPatientIdApi) refreshByPatientIdApi(formData.patientId);
      if (refreshAllApi) refreshAllApi();
      if (typeof handleSaveTask === "function") handleSaveTask();
      if (typeof fetchDocumentById === "function") fetchDocumentById();

      setFullName(patient && patient.patient_name ? patient.patient_name : "");
      setFormData({
        id: "",
        patientId: patient && patient.patient_id ? patient.patient_id : "",
        documentType: "",
        otherDocumentType: "",
        status: "",
        staffMemberId: "",
        priority: "-1",
        name: "",
      });
      setImageFile("");
      setImageAsPreview("");
      $("#idClosePopup").trigger("click");
    },
  });

  const [staffMember, setStaffMember] = useState("");
  const [staffMemberId, setStaffMemberId] = useState(null);
  const [showOption, setShowOption] = useState(false);
  const [, setImageAsPreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [fullName, setFullName] = useState("");
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    patientId: "",
    documentType: "",
    otherDocumentType: "",
    status: "",
    staffMemberId: "",
    priority: "-1",
  });

  const [documentTypes, setDocumentTypes] = useState(false);

  let tenantVal = useSelector((state) => state.auth.user?.tenant);
  if (!tenantVal) tenantVal = localStorage.getItem("kinesin-tenant");
  const fetchProfileInfo = async () => {
    try {
      const axiosInstance = createAxiosInstance(true);
      const response = await axiosInstance.get(`${WHO_AM_I}`);
      if (
        response &&
        response.data &&
        response.data.staffMember &&
        response.data.staffMember.id
      ) {
        setStaffMemberId(response.data.staffMember.id);
        setFormData({
          ...formData,
          staffMemberId: response.data
            ? response.data.staffMember.id
            : null,
        });
      }
    } catch (error) {
      errorHandling(error);
    }
  };
  const fetchDocumentTypes = async () => {
    try {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${GET_ALL_DOCUMENT_TYPES}`
      );
      let docTypes = [];
      if (response && response.data) {
        response.data.forEach((element) => {
          if (element && element.id && element.name) {
            docTypes.push({ value: element.id, name: element.name });
          }
        });
      }
      setDocumentTypes(docTypes);
    } catch (error) {
      errorHandling(error);
    }
  };

  const handleCloseModal = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    resetFormParam();
    resetFormState();
  };
  const resetFormState = () => {
    if (fromPatient) {
      setFullName("");
      setFormData({
        id: "",
        name: "",
        patientId: patient.id,
        documentType: "",
        otherDocumentType: "",
        status: "",
        staffMemberId: "",
        priority: "-1",
      });
    }

    setImageFile("");
    setImageAsPreview("");
  };

  const fetchUser = async () => {
    try {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${STAFF_MEMBERS_CONTROLER_URL}`
      );

      setStaffMember(response.data);
    } catch (error) {
      errorHandling(error);
    }
  };

  useEffect(() => {
    setFullName(patient && patient.patient_name ? patient.patient_name : "");

    setImageAsPreview("");
    setImageFile("");
    setFormData({
      id: "",
      name: "",
      patientId: patient && patient.patient_id ? patient.patient_id : "",
      documentType: "",
      otherDocumentType: "",
      status: "",
      staffMemberId: "",
      priority: "-1",
    });
    fetchUser();
    fetchDocumentTypes();
    fetchProfileInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantVal, patient]);

  const [options, setOptions] = useState([]);

  const getData = async (searchTerm) => {
    if (!searchTerm) setOptions([]);

    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.get(
      `${tenantVal}${PATIENT_SEARCH_AUTOCOMPLETE_URL}/${searchTerm}`
    );

    if (response && response.data && response.data.length > 0) {
      const updatedOptions = response.data.map((p) => {
        return {
          id: p.id,
          title:
            p.firstName +
            (p.surname ? " " + p.surname : "") +
            (p.dateOfBirth
              ? " (" + moment(p.dateOfBirth).format("DD-MM-YYYY") + ")"
              : ""),
        };
      });
      setOptions(updatedOptions);
    } else setOptions([]);
  };

  const onInputChange = (event, value) => {
    if (value && value.length > 0) {
      getData(value);
    } else {
      setTimeout(() => {
        setOptions([]);
      }, 0);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [formParam, setFormParam] = useState({
    errors: {
      email: "",
    },
    submitted: false,
  });

  const validateForm = () => {
    let formIsValid = true;
    let f = Object.assign({}, formParam);
    f.errors.documentType = "";
    f.errors.status = "";
    f.errors.patient = "";
    f.errors.priority = "";
    f.errors.name = "";
    if (!formData.documentType) {
      formIsValid = false;
      f.errors.documentType = "*Please select document type.";
    }
    if (!formData.patientId && !patient && imageFile) {
      formIsValid = false;
      f.errors.patient = "*Please select patient.";
    }
    if (!formData.name) {
      formIsValid = false;
      f.errors.name = "*Please enter document name.";
    }
    setFormParam(f);
    return formIsValid;
  };

  const resetFormParam = () => {
    setImageAsPreview(null);
    setImageFile(null);
    setFormParam({
      errors: {
        email: "",
      },
      submitted: false,
    });
  };

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const handleSave = () => {
    formParam.submitted = true;
    if (!validateForm()) return;

    uploadDocument.mutate({
      imageFile,
      formData,
      patient,
    });
  };

  const errorHandling = (error) => {
    console.error(error);
    toast.error(error.message);
    if (error && error.response && error.response.status) {
      if (error.response.status === 403) {
        logoutFromHelper();
        dispatch(logout());
        dispatch(removeuser());
        navigate(pathGenerators.auth.logout());
      }
    }
  };
  const handleImagePreview = async (e) => {
    let image_as_base64 = URL.createObjectURL(e.target.files[0]);
    let image_as_files = e.target.files[0];

    setImageAsPreview(image_as_base64);
    setImageFile(image_as_files);
  };

  return (
    <>
      <div
        className="modal warningmodal_box custom-modal-wrap"
        id="addDocumentModal"
      >
        <div className="modal-dialog add_document-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Document </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="idClosePopup"
                onClick={handleCloseModal}
              ></button>
            </div>

            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label>Upload Document</label>
                    <div className="documentUploadbtn">
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleImagePreview}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="requiredValidator">Document Name</label>
                    <div className="priorityform">
                      <input
                        className="form-control2"
                        name="name"
                        value={formData.name}
                        placeholder="Document Name"
                        onChange={handleChange}
                      />
                      {formParam.submitted && (
                        <div className="errorMsg text-start">
                          {formParam.errors.name}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>Status</label>
                    <Select
                      name="status"
                      options={Documentstatus.map((Status) => ({
                        label: Status.name,
                        value: Status.value,
                      }))}
                      value={formData.status}
                      onChange={(value) =>
                        setFormData({ ...formData, status: value })
                      }
                      fullWidth
                    />
                    {formParam.submitted && (
                      <div className="errorMsg text-start">
                        {formParam.errors.status}
                      </div>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label>Patient</label>
                    <Autocomplete

                      disablePortal
                      id="combo-box-demo"
                      value={fullName || null}

                      options={options}
                      getOptionLabel={(option) =>
                        option && option.title ? option.title : fullName
                      }
                      onInputChange={onInputChange}
                      onChange={(event, newValue) => {
                        setFullName(newValue ? newValue.title : "");
                        setFormData({
                          ...formData,
                          patientId: newValue ? newValue.id : "",
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="" />
                      )}
                    />
                    {imageFile && !patient && formParam.submitted && (
                      <div className="errorMsg text-start">
                        {formParam.errors.patient}
                      </div>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>Staff member </label>
                    <Select
                      name="staffMemberId"
                      options={
                        staffMember
                          ? staffMember.map((Staff) => ({
                              label: `${Staff.active ? "✅ " : ""}${Staff.firstName} ${Staff.lastName}${Staff.staffRole ? ` (${Staff.staffRole.toLowerCase()})` : ""}`,
                              value: Staff.id,
                            }))
                          : []
                      }
                      value={staffMemberId}
                      onChange={(value) =>
                        setFormData({ ...formData, staffMemberId: value })
                      }
                      fullWidth
                    />
                    {formParam.submitted && (
                      <div className="errorMsg text-start">
                        {formParam.errors.staffMemberId}
                      </div>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>Priority</label>
                    <div className="priorityform">

                      <div
                        className={
                          formData.priority === 0
                            ? "pridot"
                            : formData.priority === 1
                            ? "pridotYellow"
                            : formData.priority === 2
                            ? "pridotGreen"
                            : ""
                        }
                      ></div>
                      <Select
                        name="priority"
                        options={TaskPriority.map((Priority) => ({
                          label: Priority.name,
                          value: Priority.value,
                        }))}
                        value={formData.priority}
                        onChange={(value) =>
                          setFormData({ ...formData, priority: value })
                        }
                        fullWidth
                      />
                      {formParam.submitted && (
                        <div className="errorMsg text-start">
                          {formParam.errors.priority}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="requiredValidator">Document type</label>
                    <Select
                      name="documentType"
                      options={
                        documentTypes
                          ? documentTypes.map((dt) => ({
                              label: dt.name,
                              value: dt.value,
                            }))
                          : []
                      }
                      value={formData.documentType}
                      onChange={(value) => {
                        setShowOption(value === "Other");
                        setFormData({ ...formData, documentType: value });
                      }}
                      fullWidth
                    />
                    {showOption ? (
                      <div className="mt-3 ">
                        <input
                          className="form-control"
                          id="designation"
                          value={formData.otherDocumentType}
                          type="text"
                          name="otherDocumentType"
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter New Document Type"
                          required
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {formParam.submitted && (
                      <div className="errorMsg text-start">
                        {formParam.errors.documentType}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                className="custom_btn savwidth"
                type="submit"
                disabled={uploadDocument.isPending}
                onClick={handleSave}
                style={
                  uploadDocument.isPending
                    ? { backgroundColor: "#9ca3af", cursor: "not-allowed" }
                    : {}
                }
              >
                {uploadDocument.isPending ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { DocumentModal };
